<template>
  <div>
    <!-- search input -->
    <b-row>
      <!-- search input -->
      <b-col>
        <section>
          <b-button
            v-b-modal.modal-filter-orders
            variant="outline-primary"
            class="d-flex"
          >
            <feather-icon icon="FilterIcon" />Filter
          </b-button>
        </section>
      </b-col>
      <b-col>
        <b-form-group
          v-if="dataFiltered == true"
          class="d-flex justify-content-center"
        >
          <!-- search input -->
          <div>
            <b-form-input
              v-model="searchTerm"
              type="search"
              placeholder="search"
            />
          </div>
        </b-form-group>
      </b-col>

      <b-col class="d-flex justify-content-end">
        <section v-if="dataFiltered === true">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </section>
      </b-col>
    </b-row>
    <b-tabs content-class="mt-4" align="center">
      <b-tab title="Transactions" active>
        <div>
          <b-card title="Paid Transactions">
            <!-- table -->
            <vue-good-table
              :columns="columns"
              :rows="reconciliations"
              :rtl="direction"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
            >
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['5', '10', '15', '30', '50']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>

            <b-row>
              <b-col>
                <b-modal
                  id="modal-filter-orders"
                  title="Filter Reconcilation"
                  ok-title="Search"
                  cancel-variant="outline-secondary"
                  size="lg"
                  @ok="filterOrders"
                >
                  <b-form>
                    <b-row>
                      <b-col cols="6">
                        <b-form-group
                          label="Payment option"
                          label-for="payment-option"
                        >
                          <b-form-select
                            id="merchantId"
                            v-model="filterFopId"
                            :options="paymentOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                          label="Paid Date Range"
                          label-for="paid-date-range"
                        >
                          <flat-pickr
                            v-model="trxnDateRange"
                            class="form-control"
                            :config="{ mode: 'range', maxDate: 'today' }"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          label="Approval Type"
                          label-for="approved-by"
                        >
                          <b-form-select
                            id="approved-by"
                            v-model="setApproval"
                            :options="approval"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Order Type" label-for="order-type">
                          <b-form-select
                            id="order-type"
                            v-model="setOrderType"
                            :options="orderType"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-modal>
              </b-col>
            </b-row>

            <!-- loadings -->
            <b-overlay :show="isLoading" no-wrap rounded="sm" />
          </b-card>
        </div>
      </b-tab>
      <b-tab title="Summary">
        <section v-if="Object.keys(pricing).length" id="pricing-plan">
          <!-- pricing plan cards -->
          <b-row class="pricing-card">
            <b-col
              offset-sm-2
              sm="10"
              md="12"
              offset-lg="2"
              lg="10"
              class="mx-auto"
            >
              <b-row>
                <b-col v-for="sum in summary" :key="sum.name" md="4">
                  <b-card class="popular" align="center">
                    <div
                      v-show="pricing.standardPlan.popular"
                      class="pricing-badge text-right"
                    >
                      <b-badge variant="light-primary" pill>
                        {{ sum.parner }}
                      </b-badge>
                    </div>
                    <!--/ img -->
                    <h3>Payment Option</h3>
                    <b-card-text>{{ sum.paymentOptionName }}</b-card-text>

                    <!-- annual plan -->
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Total Transactions
                        </sub>
                        <span
                          class="pricing-basic-value font-weight-bolder text-primary"
                          >{{ sum.totalNumberOfTransaction }}</span
                        >
                      </div>
                    </div>
                    <hr />
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                          >Total Amount:
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.totalTransactionAmount }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Currency:
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.currency }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Total Fees:
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.totalFees }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                          >Total refunds deducted:</sub
                        >
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                        >
                          {{ sum.totalRefundsDeducted }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                          >Net Amount:
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.settelmentAmount }}
                        </sub>
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!--/ pricing plan cards -->
        </section>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      selectedOrderRefund: "",
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      setApproval: 2,
      approval: [
        {
          value: 0,
          text: "System",
        },
        {
          value: 1,
          text: "Manual",
        },
        {
          value: 2,
          text: "All",
        },
      ],
      orderType: [
        {
          value: 0,
          text: "All",
        },
        {
          value: 1,
          text: "System Initiated",
        },
        {
          value: 2,
          text: "Manual Created",
        },
        {
          value: 3,
          text: "Pay By Link",
        },
      ],
      setOrderType: 0,
      orderDateRange: "",
      trxnDateRange: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterFopId: 0,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",
      columns: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Order Code",
          field: "orderId",
        },

        {
          label: "Order Date",
          field: "orderDate",
        },
        {
          label: "Custom Order Code",
          field: "merchantOrderCode",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Paid Payment Option",
          field: "paymentOptionDescription",
        },
        {
          label: "Amount",
          field: "amount",
          type: "number",
        },
        {
          label: "Payment Status",
          field: "paymentStatusDescription",
        },
        {
          label: "Action Taken By",
          field: "actionTakenBy",
        },
        {
          label: "Paid Date",
          field: "transactionDate",
        },
        {
          label: "Payment RefNumber",
          field: "partnerReferenceNumber",
        },
        {
          label: "Service Number",
          field: "merchantServiceNumber",
        },
      ],
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      statusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Approved" },
        { value: "3", text: "Canceled" },
      ],
      refundStatusOptions: [
        { value: "0", text: "NotRequested" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Submitted" },
        { value: "3", text: "Approved" },
        { value: "4", text: "Sent" },
        { value: "5", text: "Rejected" },
        { value: "6", text: "Completed" },
      ],
      currencyOptions: [{ value: "ETB", text: "ETB" }],
      selectedCurrency: "ETB",
      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderRefundHistory: [],

      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
      status: "monthly",
      monthlyPlanShow: true,
      pricing: {
        basicPlan: {
          title: "Basic",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot1.svg"),
          subtitle: "A simple start for everyone",
          monthlyPrice: 0,
          yearlyPlan: {
            perMonth: 0,
            totalAnual: 0,
          },
          planBenefits: [
            "100 responses a month",
            "Unlimited forms and surveys",
            "Unlimited fields",
            "Basic form creation tools",
            "Up to 2 subdomains",
          ],
          popular: false,
        },
        standardPlan: {
          title: "Standard",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot2.svg"),
          subtitle: "For small to medium businesses",
          monthlyPrice: 49,
          yearlyPlan: {
            perMonth: 40,
            totalAnual: 480,
          },
          planBenefits: [
            "Unlimited responses",
            "Unlimited forms and surveys",
            "Instagram profile page",
            "Google Docs integration",
            "Custom “Thank you” page",
          ],
          popular: true,
        },
        enterprisePlan: {
          title: "Enterprise",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 99,
          yearlyPlan: {
            perMonth: 80,
            totalAnual: 960,
          },
          planBenefits: [
            "PayPal payments",
            "Logic Jumps",
            "File upload with 5GB storage",
            "Custom domain support",
            "Stripe integration",
          ],
          popular: false,
        },
      },
      reconciliations: [],
      summary: [],
      sheets: [
        { name: "Detail Transactions", data: [] },
        { name: "Summary", data: [] },
      ],
      searchTerm: "",
      url: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallPaymentOptions();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }
      this.setApproval === 0 || this.setApproval === 1
        ? (this.url = `/Reconciliation/api/V1.0/Reconciliation/GetReconciliation?FromPaidDate=${this.trxnStartDate}&ToPaidDate=${this.trxnEndDate}&paymentOptionId=${this.filterFopId}&approvalType=${this.setApproval}&OrderType=${this.setOrderType}`)
        : (this.url = `/Reconciliation/api/V1.0/Reconciliation/GetReconciliation?FromPaidDate=${this.trxnStartDate}&ToPaidDate=${this.trxnEndDate}&paymentOptionId=${this.filterFopId}&OrderType=${this.setOrderType}`);
      // Api call
      this.isLoading = true;
      axios
        .get(this.url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.reconciliations = res.reconciliation;
          this.summary = res.summary;
          this.sheets[0].data = [];
          res.reconciliation.map((f) => {
            this.sheets[0].data.push({
              "Merchant Name": f.merchantName,
              "Order Code": f.orderId,
              "Order Date": f.orderDate,
              "Custom Order Code": f.merchantOrderCode,
              "First Name": f.firstName,
              "Last Name": f.lastName,
              "Paid Payment Option": f.paymentOptionDescription,
              Amount: f.amount,
              "Payment Status": f.paymentStatusDescription,
              "Action Taken By": f.actionTakenBy,
              "Paid Date": f.transactionDate,
              "Payment RefNumber": f.partnerReferenceNumber,
              "Service No": f.merchantServiceNumber,
            });
          });
          this.sheets[1].data = res.summary;
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.reconciliations = [];
          this.summary = [];

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
